
import { Link } from 'react-router-dom';

export default function ServicesGrid() {
  const services = [
    {
      title: 'الإنشاءات والطرق',
      description: 'تصميم وتنفيذ طرق وأرصفة وبنية تحتية وفق المواصفات المعتمدة.',
      icon: 'ri-road-map-line',
      path: '/services/construction'
    },
    {
      title: 'البترول',
      description: 'توريد وتشغيل وصيانة منشآت وأنابيب وخزانات مع تقارير NDT وHSE.',
      icon: 'ri-oil-line',
      path: '/services/oil'
    },
    {
      title: 'الذهب',
      description: 'سبائك وDore بفحص وصهر بمعايير سويسرية والتزام KYC/AML.',
      icon: 'ri-coins-line',
      path: '/services/gold'
    },
    {
      title: 'التسليح',
      description: 'حلول معتمدة ضمن ضوابط التصدير وشهادة المستخدم النهائي.',
      icon: 'ri-shield-line',
      path: '/services/defense'
    },
    {
      title: 'الاستشارات',
      description: 'دراسات جدوى وإدارة عقود ومخاطر وخطط توسع صناعي ولوجستي.',
      icon: 'ri-lightbulb-line',
      path: '/services/consulting'
    }
  ];

  return (
    <section className="py-20 bg-[#F7F7F7]">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#2B2C2E] mb-6">خدماتنا</h2>
          <p className="text-xl text-[#595A5C] max-w-2xl mx-auto">
            حلول متخصصة تغطي خمسة مجالات رئيسية، اختر الخدمة لمعرفة التفاصيل.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.slice(0, 3).map((service, index) => (
            <Link
              key={index}
              to={service.path}
              className="block group"
              role="link"
              aria-label={`تفاصيل خدمة ${service.title}`}
            >
              <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                  <i className={`${service.icon} text-white text-xl`} aria-hidden="true"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">
                  {service.title}
                </h3>
                <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                  {service.description}
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center justify-center px-4 py-2 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                    تفاصيل الخدمة
                    <i className="ri-arrow-left-line mr-2" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-4xl mx-auto">
          {services.slice(3).map((service, index) => (
            <Link
              key={index + 3}
              to={service.path}
              className="block group"
              role="link"
              aria-label={`تفاصيل خدمة ${service.title}`}
            >
              <div className="bg-white rounded-xl shadow-sm hover:shadow-xl border-t-4 border-[#E71B25] p-6 min-h-[280px] flex flex-col transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                <div className="w-12 h-12 bg-[#E71B25] rounded-full flex items-center justify-center mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                  <i className={`${service.icon} text-white text-xl`} aria-hidden="true"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-3 min-h-[56px] flex items-center">
                  {service.title}
                </h3>
                <p className="text-[#595A5C] mb-6 leading-relaxed flex-grow min-h-[72px]">
                  {service.description}
                </p>
                <div className="mt-auto">
                  <span className="inline-flex items-center justify-center px-4 py-2 border-2 border-[#E71B25] text-[#2B2C2E] rounded-lg font-medium transition-all duration-300 group-hover:bg-[#E71B25] group-hover:text-white whitespace-nowrap">
                    تفاصيل الخدمة
                    <i className="ri-arrow-left-line mr-2" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        
        <div className="text-center">
          <Link to="/services">
            <span className="inline-flex items-center justify-center px-8 py-4 bg-[#E71B25] text-white rounded-lg font-medium text-lg hover:bg-[#d11620] transition-all duration-300 shadow-sm hover:shadow-md whitespace-nowrap">
              عرض جميع الخدمات
              <i className="ri-arrow-left-line mr-2" aria-hidden="true"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
